import React from 'react';
import { ChevronLeft } from 'lucide-react';

type Props = {
  title: string;
  onBack: () => void;
};

const SubpageHeader: React.FC<Props> = ({ title, onBack }) => {
  return (
    <header className="flex items-center gap-3 px-1 py-1">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-sm transition hover:bg-slate-50"
        aria-label="Back"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      <h1 className="text-[28px] font-semibold tracking-[-0.03em] text-slate-950">{title}</h1>
    </header>
  );
};

export default SubpageHeader;
